import { Table } from "react-bootstrap";
export default function TestSample({ head, data, changeData, setData }) {
  //   console.log("sssssssssssssssssss", data);
  return (
    <div className="m-1">
      <Table striped bordered hover>
        <thead>
          <tr>
            {head.map((v) => (
              <th>{v}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((value) => (
            <tr>
              {head.map((v) => {
                return (
                  <td>
                    <input
                      className="form-control "
                      value={
                        typeof value[v] != "string" &&
                        value[v] != "number" &&
                        value[v]?.length > 0
                          ? value[v].map((v) => v)
                          : value[v]
                      }
                      disabled={v == "id" ? true : false}
                      onChange={(e) => {
                        let x = e.target.value;
                        changeData(
                          data,
                          value.id,
                          v,
                          typeof value[v] != "string" && value[v] != "number"
                            ? e.target.value.split(",")
                            : e.target.value,
                          setData
                        );
                      }}
                    />
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
